
import DataHome from '@/views/setting/components/institute/homes/data.vue'
import FlowHome from '@/views/setting/components/institute/homes/flow.vue'
import ApiHome from '@/views/setting/components/institute/homes/api.vue'
import FullLoading from '@/components/full_loading/index.vue'
import TypeTable from './components/type_table.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import { CommonService } from '@/services'
import { Component, Ref, Vue } from 'vue-property-decorator'


@Component({
    name: 'institute',
    components: {
        DataHome,
        FlowHome,
        ApiHome,
        FullLoading,
        TypeTable,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private list: any[] = []
    private isLoading = true
    private pathName = ''

    private mounted() {
        this.pathName = this.$route.name || ''
        this.getList()
    }

    async getList() {
        this.isLoading = true
        const result = await CommonService.getIArticleTypes({})
        if (result.status === 200) {
            let filteredList = result.data
            if (this.pathName === 'ContentInstitute') {
                filteredList = result.data.filter((item: any) => item.name.indexOf('酷公司/') === -1)
            } else {
                filteredList = result.data.filter((item: any) => item.name.indexOf('酷公司/') !== -1)
            }
            await this.fetchArticleCounts(filteredList)
            this.list = filteredList
            this.pageTotal = this.list.length
        }
        this.isLoading = false
    }

    async fetchArticleCounts(typeList: any[]) {
        const promises = typeList.map(async (item: any) => {
            const result = await CommonService.getIArticleList({ type_id: item.id, page_size: 1 })
            if (result.status === 200) {
                item.article_count = result.data.page_total || 0
            }
        })
        await Promise.all(promises)
    }
    /** 删除文章分类 */
    private async deleteType(type: any) {
        const params = { id: type.id }
        const result = await CommonService.deleteIArticleType(params)
        if (result.status === 200) {
            this.list.splice(this.list.indexOf(type), 1)
            --this.pageTotal
            this.$message({
                type: 'success',
                message: '删除成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }

    // 分页
    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getList)
    }

    // 删除
    private onDelete(type: any) {
        this.$confirm('你正在删除文章类别, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.deleteType(type)
        })
    }

    openUrl(url: string) {
        window.open('/setting/help' + url)
    }
}
